import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'estate-labels': _ctx.isDetail, 'estate-card__labels': !_ctx.isDetail })
  }, [
    (_ctx.ad.estateType === 500)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["label-project", { 'estate-label': _ctx.isDetail }])
        }, _toDisplayString(_ctx.$t('AdLabels.is-developer-project')), 3))
      : _createCommentVNode("", true),
    (_ctx.ad.isReserved)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["label-reserved", { 'estate-label': _ctx.isDetail }])
        }, _toDisplayString(_ctx.$t('AdLabels.is-reserved')), 3))
      : _createCommentVNode("", true),
    (_ctx.ad.isSold)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass(["label-sold", { 'estate-label': _ctx.isDetail }])
        }, _toDisplayString(_ctx.$t('AdLabels.is-sold')), 3))
      : _createCommentVNode("", true),
    (_ctx.ad.isArchived)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass(["label-new label-archived", { 'estate-label': _ctx.isDetail }])
        }, _toDisplayString(_ctx.$t('AdLabels.is-archived')), 3))
      : _createCommentVNode("", true)
  ], 2))
}